import angular from 'angular';

// Create the module where our functionality can attach to
let servicesModule = angular.module('fiapiApp.services', []);

import ScheduleService from './schedules.service';
servicesModule.service('Schedules', ScheduleService);

import UpdateService from './updates.service';
servicesModule.service('Updates', UpdateService);

import EventService from './events.service';
servicesModule.service('Events', EventService);

import DirectoryService from './directory.service';
servicesModule.service('Directory', DirectoryService);

import BuildService from './build.service';
servicesModule.service('Build', BuildService);

import FreightTimeService from './freightTime.service';
servicesModule.service('FreightTime', FreightTimeService);

import MediaService from './media.service';
servicesModule.service('Media', MediaService);


export default servicesModule;



// WEBPACK FOOTER //
// ./client/components/services/index.js